type UserState = any;
const userStates: UserState = {};

export default userStates;
